<template lang="pug">
  .business-list-file
    .list-file-title Archivos
    b-row(cols="1" cols-sm="2" cols-md="4" no-gutters align-v="stretch")
      b-col(v-for="file in files")
        .file-list-item
          .file-list-item-footer
            font-awesome-icon(:icon="['fas', 'file-pdf']" style="color:#D32B2B")
            a(:href="file.url" download target="_blank" style="font-size: 14px") {{file.name}}
            font-awesome-icon.btn-remove-file(@click="removeFile(file)" :icon="['far', 'trash-alt']")
            font-awesome-icon.btn-copy-url(@click="copyUrl(file.url)" :icon="['far', 'clone']")
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    files: {
      type: Array,
      default: () => []
    },
    service: Object
  },
  methods: {
    ...mapActions(['deleteBusinessFolderFile']),
    async removeFile (file) {
      const modalMsg = `¿Está seguro que desea eliminar el archivo ${file.name}?`
      const modalOptions = {
        title: 'Eliminar Archivo',
        okTitle: 'Eliminar',
        okVariant: 'danger'
      }
      const confirmed = await this.$bvModal.msgBoxConfirm(modalMsg, modalOptions)
      if (confirmed) {
        const { id } = file
        const response = await this.deleteBusinessFolderFile(id)
        if (response.status >= 400 && response.status < 600) {
          this.$root.$bvToast.toast('No se pudo eliminar el archivo', {
            title: 'Oops!',
            variant: 'danger'
          })
        }
        this.$emit('done')
      }
    },
    copyUrl (text) {
      const el = document.createElement('textarea')
      el.value = text
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.$root.$bvToast.toast('Link copiado al portapapeles', {
        title: 'Ok!',
        variant: 'success'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.list-file-title {
  font-weight: bold;
  margin-bottom: 16px;
}
.file-list-item {
  height: calc(100% - 0.5rem);
  .file-list-item-footer {
    text-decoration: none;
    padding: 8px 60px 8px 10px;
    position: relative;
    svg {
      margin-right: 10px;
    }
  }
  color: #7F828F;
  margin: 0.25rem;
  border: 1px solid #E4E4E4;
  border-radius: 5px;
}
.btn-remove-file {
  position: absolute;
  color: #D32B2B;
  right: 30px;
  top: 12px;
  cursor: pointer;
}
.btn-copy-url {
  position: absolute;
  color: var(--primary);
  right: 3px;
  top: 12px;
  cursor: pointer;
}
</style>